import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { TABLE_HEADER_BACKGROUND_COLOR } from '../../../constants/colors';
import { OrderStatusEnum } from '../../../enums/orderStatus';
import { t } from 'i18next';
import { useTranslation } from 'react-i18next';


interface Props {
  value: string,
  onChange: (newValue: string) => void,
}

export default function ProductTabPanel({ value, onChange,  }: Props) {
  const { t } = useTranslation("global");

  return (
    <Box sx={{ width: '100%', backgroundColor: TABLE_HEADER_BACKGROUND_COLOR, borderRadius: '10px 10px 0 0' }}>
      <Box sx={{ borderColor: 'divider' }}>
        <Tabs value={value} onChange={(e: any, newValue: OrderStatusEnum) => {
          onChange(newValue)
         
        }} aria-label="basic tabs example" variant="scrollable"
          scrollButtons="auto">
          <Tab label={t("masterProduct_page.All")} value={"ALL"} sx={{ textTransform: 'none' }} />
          <Tab label={t("masterProduct_page.Category")} value={"HAS_CATEGORY"} sx={{ textTransform: 'none' }} />
          <Tab label={t("masterProduct_page.No Category")} value={"NO_CATEGORY"} sx={{ textTransform: 'none' }} />
        </Tabs>
      </Box>
    </Box>
  );
}
